(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSAreaDetailController', SSAreaDetailController);

    SSAreaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSArea'];

    function SSAreaDetailController($scope, $rootScope, $stateParams, previousState, entity, SSArea) {
        var vm = this;

        vm.sSArea = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSAreaUpdate', function(event, result) {
            vm.sSArea = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
